<template>
	<div class="row form-group">
		<div class="col-md-12">
			<div class="d-flex justify-content-between">
				<label>
					<u>{{ $t('portfolioPhoto.portfolioFile') }}</u>
				</label>
				<label class="btn btn-sm btn-flat-info btn-outline-info" for="portfoliofile">{{
					$t('portfolioPhoto.uploadFile')
				}}</label>
				<input type="file" id="portfoliofile" ref="portfoliofile" style="display:none" multiple
					@change="onPortfolioFileChange" />
			</div>
			<table style="width:100%">
				<tr v-for="(portfolio, index) in model.attach_file_list" :key="index">
					<td style="width:20%">
						<img :src="readFromUrl(portfolio)" alt="">
					</td>
					<td style="width:25%" class="mt-2" :class="{ 'text-red': portfolio.invalid_file }">
						{{ portfolio.name }}
					</td>
					<td style="width:30%">
						<textarea class="ts-w-full ts-border form-control" rows="1" v-model="portfolio.remarks"
							:placeholder="$t('portfolioPhoto.remarks')"></textarea>
					</td>
					<td class="text-center" style="width:5%">
						<a href="#" class="text-red" v-if="portfolio.progressing == 100"
							@click.prevent="onRemoveFile(index, portfolio)">
							<i class="fa fa-times"></i>
						</a>
					</td>
				</tr>
			</table>
		</div>
	</div>
</template>
<script>
import httpClient from '@/http-client'
import { mapActions, mapState } from 'vuex'

export default {
	name: 'portfolioAttachFile',
	props: ['value'],
	data() {
		return {
			model: {},
			selectedPortfolioFiles: []
		}
	},
	created() {
		this.model = this.value
		this.setEdit()
	},
	computed: {
		...mapState('portfolioPhoto', ['edit_data']),
		isEdit() {
			return !_.isEmpty(this.edit_data) && this.edit_data !== undefined
		}
	},
	methods: {
		...mapActions('portfolioPhoto', ['removeFileUploaded']),
		onPortfolioFileChange(e) {
			let files = e.target.files
			this.model.attach_file_list = [
				...this.model.attach_file_list,
				..._.map(files, file => ({
					file_path: null,
					original_file_name: file.name,
					remarks: null,
					name: file.name,
					size: parseInt(file.size / 1024),
					size_text: parseInt(file.size / 1024) + 'KB',
					type: file.type,
					progressing: 0,
					invalid_file: this.validate(file),
					file: file,
					uploaded: false,
					storage_path: null
				}))
			]
			_.forEach(
				this.model.attach_file_list.filter(file => file.uploaded == false),
				(f, index) => {
					if (!this.validate(f.file)) {
						let frm = new FormData()
						frm.append('file', f.file)
						frm.append('file_type', 1)
						httpClient
							.post('/api/portfolio-photos/upload-files', frm, {
								onUploadProgress: el => {
									if (el.lengthComputable) {
										f.progressing = Math.round((el.loaded * 100) / el.total)
									}
								}
							})
							.then(response => {
								f.uploaded = true
								f.storage_path = response.data.file_path
								f.file_path = response.data.file_path
							})
							.catch(error => {
								this.$toasted.error(error.message)
							})
					}
				}
			)
		},
		validate(file) {
			let ALLOW_FILE = [
				'image/png',
				'image/jpeg',
				'application/pdf',
				'application/vnd.openxmlformats-officedocument.presentationml.presentation',
				'application/vnd.ms-powerpoint',
				'application/vnd.ms-excel',
				'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
				'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
				'application/msword'
			]

			if (file.size > 10000000 * 10 || !ALLOW_FILE.includes(file.type)) {
				return true
			}

			return false
		},
		onRemoveFile(index, record) {
			this.removeFileUploaded({
				file_path: record.storage_path
			})
			let file_index = this.model.attach_file_list.indexOf(
				...this.model.attach_file_list.filter(
					f => f.file_path == record.storage_path
				)
			)
			this.model.attach_file_list.splice(file_index, 1)

		},
		readFromUrl(file) {
			if (file.file instanceof File) {
				return URL.createObjectURL(file.file);
			}
			return file.storage_path;
		},
		setEdit() {
			if (this.isEdit) {
				this.model.attach_file_list = this.edit_data.gallery_photos
					.map(el => ({
						name: el.original_file_name,
						size: 0,
						size_text: 0,
						type: el.mime_type,
						progressing: 100,
						invalid_file: false,
						file: el.file_path,
						file_path: el.file_path,
						uploaded: true,
						storage_path: el.storage_path,
						remarks: el.remarks
					}))
			}
		}
	}
}
</script>
  